import PropTypes from 'prop-types';

/**
 * Get a PropType for React useRef
 * @param {Element} HTMLElementType Always pass "Element", it excepts the HTMLElement prototype. It cannot be sourced from here.
 * @returns {PropType} PropType for React useRef
 */
function getRefPropType(HTMLElementType) {
	return PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({
			current: PropTypes.instanceOf(HTMLElementType)
		})
	]);
}

export default getRefPropType;
